module.exports = __webpack_public_path__ + "static/media/profile.12f089b4.svg";